<template>
  <List :mapState="'papeleriaProductsSubCategories'" :allDispatch="'papeleriaProductsSubCategoriesAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/papeleria/products/subcategories/list.vue